import React from 'react';
import { AxiosResponse } from 'axios';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { showError } from '../utils/errors';
import { ModalStyle } from './styles/Modal';

type Props = any;
const TicketModal: React.FC<Props> = ({
  show,
  setShow,
  loading,
  createSupportTicket,
}) => {
  const initialValues = { title: '', message: '' };
  const { register, handleSubmit, formState, reset, errors } = useForm({
    defaultValues: { ...initialValues },
    mode: 'onChange',
  });

  const handleClose = () => setShow(false);

  const onSubmit = (data: any) => {
    console.log(data);
    createSupportTicket(data).then((res: AxiosResponse) => {
      return res.status === 201 ? handleClose() : '';
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalStyle>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group controlId="formBasicTitle">
                <Form.Label>Ticket Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  placeholder="Enter title"
                  ref={register({
                    required: 'Title is required',
                    minLength: {
                      value: 3,
                      message: 'Must be at least 3 chars long',
                    },
                  })}
                />
              </Form.Group>
              {showError('title', errors)}

              <Form.Group controlId="formBasicMessgae">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  type="text"
                  name="message"
                  placeholder="Enter message"
                  ref={register({
                    required: 'Message is required',
                    minLength: {
                      value: 5,
                      message: 'Must be at least 5 chars long',
                    },
                  })}
                />
              </Form.Group>
              {showError('message', errors)}

              <Button
                block
                variant="primary"
                type="submit"
                disabled={!formState.isValid}
              >
                {loading ? (
                  <Spinner animation="border" variant="light" />
                ) : (
                  'Submit'
                )}
              </Button>
            </Form>
          </ModalStyle>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => reset(initialValues)}>
            Reset
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TicketModal;
